import { render, staticRenderFns } from "./GsCalendarItem.vue?vue&type=template&id=19da4f66&scoped=true"
import script from "./GsCalendarItem.vue?vue&type=script&lang=js"
export * from "./GsCalendarItem.vue?vue&type=script&lang=js"
import style0 from "./GsCalendarItem.vue?vue&type=style&index=0&id=19da4f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da4f66",
  null
  
)

export default component.exports